import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form';
import FieldError from './FieldError';

export default function TextField({
    name,
    placeholder,
    label,
    info,
    type,
    onChange,
    disabled,
    customErrorMessage,
    cols,
    rows,
    registerOptions = {}
}) {
    const { register, errors } = useFormContext();
    const [focused, setFocused] = useState(false);

    // Shared style for input and textarea
    const baseFieldStyle = {
        width: "100%",
        padding: "0.625em 0.75em",
        border: "1px solid #dbdbdb",
        borderRadius: "4px",
        boxSizing: "border-box",
        outline: "none",
        background: "#fff",
        transition: "border-color 0.2s",
        fontFamily: "inherit",
        lineHeight: 1.5,
        minHeight: type === "textarea" ? "120px" : "2.25em",
        ...(focused && { borderColor: "#3273dc" }) // Bulma's $primary
    };

    const styles = {
        wrapper: {
            marginBottom: "1.5rem",
        },
        label: {
            display: "block",
            fontWeight: "bold",
            marginBottom: "0.5rem",
            color: "#26344a", // $primary-dark
            fontSize: "1.8rem",
        },
        required: {
            color: "#ff3860",
            marginLeft: "0.25rem",
        },
        help: {
            color: "#23d160",
            fontSize: "1.4rem",
            marginTop: "0.25rem",
        }
    };

    return (
        <div style={styles.wrapper}>
            <label style={styles.label}>
                {label}
                {registerOptions['required'] && <span style={styles.required}>*</span>}
            </label>
            <div>
                {type === 'textarea' ? (
                    <textarea
                        style={baseFieldStyle}
                        name={name}
                        onChange={onChange}
                        disabled={disabled}
                        ref={register(registerOptions)}
                        cols={cols}
                        rows={rows}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                    />
                ) : (
                    <input
                        style={baseFieldStyle}
                        type={type}
                        placeholder={placeholder}
                        name={name}
                        onChange={onChange}
                        disabled={disabled}
                        ref={register(registerOptions)}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                    />
                )}
            </div>
            {info && <p style={styles.help}>{info}</p>}
            <FieldError errors={errors[name]} customErrorMessage={customErrorMessage} />
        </div>
    )
}
